/**
 * @sw-package b2b
 */
interface StorefrontWindow extends Window {
    PluginManager: {
        register: (pluginName: string, plugin: any, selector: string) => void;
    };
}

declare var window: StorefrontWindow;

const PluginManager = window.PluginManager;

PluginManager.register('B2bDeleter', () => import('./plugin/b2b-deleter.plugin'), '[data-b2b-deleter]');
PluginManager.register('B2bContextModal', () => import('./plugin/b2b-context-modal.plugin'), '[data-b2b-context-modal]');
PluginManager.register('B2bContextSwitcher', () => import('./plugin/b2b-context-switcher.plugin'), '[data-b2b-context-switcher]');
PluginManager.register('B2bEmployeeDeactivator',  () => import('./plugin/b2b-employee-deactivator.plugin') , '[data-b2b-employee-deactivator]');
PluginManager.register('B2bRolePermissionTree',  () => import('./plugin/b2b-role-permission-tree.plugin'), '[data-b2b-role-permission-tree]');
PluginManager.register('B2bRestoreSwitch', () => import('./plugin/b2b-restore-switch.plugin'), '[data-b2b-restore-switch]');
PluginManager.register('B2bListPermissionsByRole', () => import('./plugin/b2b-list-permissions-by-role.plugin'), '[data-b2b-list-permissions-by-role]');
PluginManager.register('B2bEmployeeFormValidation', () => import('./plugin/b2b-employee-form-validation/b2b-employee-form-validation.plugin'), '[data-b2b-employee-form-validation]');
PluginManager.register('B2bNotification', () => import('./plugin/b2b-notification.plugin'), '[data-b2b-notification]');
PluginManager.register('B2bEmployeeSearch', () => import('./plugin/b2b-employee-search/b2b-employee-search.plugin'), '[data-b2b-employee-search]');
/**
 * @deprecated tag:v6.8.0 - Use B2bEmployeeSearch instead
 */
PluginManager.register('B2bEmployeeContent', () => import('./plugin/listing/listing.plugin'), '[data-b2b-employee-content]');
